import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../../services/common/api-service.service';
@Component({
  selector: 'app-merchant-calendar',
  templateUrl: './merchant-calendar.component.html',
  styleUrls: ['./merchant-calendar.component.scss'],
})
export class MerchantCalendarComponent implements OnInit {
  today = new Date();

  month = this.today.getMonth();

  year = this.today.getFullYear();

  monthName = '';

  weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  calendarDays: any[] = [];
  merchantId:any;
  /*
 Dummy blocked dates
 Later replace with API data
*/

  blockedDates:any[]=[];

  filteredBlockedDates: any[] = [];

  // Popup

  showBlockForm = false;
  showDetails=false;

selectedDate:any=null;

  blockForm!: FormGroup;

  constructor(private fb: FormBuilder, private apiService: ApiServiceService) {}

  ngOnInit(){

 this.merchantId =
 localStorage.getItem('merchantId');


 this.createBlockForm();


 this.loadBlockedDates();


}

 createBlockForm() {

  this.blockForm = this.fb.group({

    date: [
      '',
      Validators.required
    ],

    blocked_for: [
      '',
      Validators.required
    ],

    customer_name: [
      ''
    ],

    customer_phone: [
      ''
    ],

    function_name: [
      ''
    ],

    location: [
      ''
    ],

    details: [
      ''
    ],

    reason: [
      ''
    ],

  });

}
loadBlockedDates(){

this.apiService
.getBlockedDates(this.merchantId)
.subscribe({

next:(res:any)=>{


console.log("API BLOCKED DATES",res.data);


this.blockedDates = res.data.map((item:any)=>{


let dateObj = new Date(item.date);


return {


...item,


day: dateObj.getDate(),


month: dateObj.getMonth(),


year: dateObj.getFullYear(),


type:item.blocked_for


};


});



console.log(
"Formatted Dates",
this.blockedDates
);



this.generateCalendar();


},


error:(err)=>{

console.log(err);

}


});


}

  generateCalendar() {

  this.monthName = new Date(
    this.year,
    this.month
  ).toLocaleString('default', {
    month: 'long'
  });

  // Total days in current month
  const totalDays = new Date(
    this.year,
    this.month + 1,
    0
  ).getDate();

  // Which weekday the month starts on (0=Sun ... 6=Sat)
  const firstDay = new Date(
    this.year,
    this.month,
    1
  ).getDay();

  this.calendarDays = [];

  // Empty cells before first date
  for (let i = 0; i < firstDay; i++) {
    this.calendarDays.push(null);
  }

  // Actual dates
  for (let i = 1; i <= totalDays; i++) {
    this.calendarDays.push(i);
  }

  this.filterCards();
}

  filterCards(){

this.filteredBlockedDates = this.blockedDates.filter(

(x:any)=>


x.month === this.month &&

x.year === this.year


);


}

  getDateType(date:any){


let item = this.blockedDates.find(

(x:any)=>

x.day === date &&

x.month === this.month &&

x.year === this.year


);



return item?.blocked_for;


}

  selectDate(date: any) {
    console.log('Selected Date', date);
  }

  previousMonth() {
    this.month--;

    if (this.month < 0) {
      this.month = 11;

      this.year--;
    }

    this.generateCalendar();
  }

  nextMonth() {
    this.month++;

    if (this.month > 11) {
      this.month = 0;

      this.year++;
    }

    this.generateCalendar();
  }

  // OPEN POPUP

  openBlockForm() {
    this.showBlockForm = true;
  }

  // CLOSE POPUP

  closeBlockForm() {

  this.showBlockForm = false;

  this.blockForm.reset({
    blocked_for:'',
    date:'',
    customer_name:'',
    customer_phone:'',
    function_name:'',
    location:'',
    details:'',
    reason:''
  });

}

  // Dropdown change

  changeBlockType() {

  const type = this.blockForm.value.blocked_for;


  // Remove all existing validators first

  this.blockForm.get('customer_name')?.clearValidators();

  this.blockForm.get('customer_phone')?.clearValidators();

  this.blockForm.get('function_name')?.clearValidators();

  this.blockForm.get('location')?.clearValidators();

  this.blockForm.get('details')?.clearValidators();

  this.blockForm.get('reason')?.clearValidators();



  // Weddingly Booking validation

  if(type === 'Weddingly Booking') {


    this.blockForm.get('customer_name')
    ?.setValidators([
      Validators.required
    ]);


    this.blockForm.get('customer_phone')
    ?.setValidators([
      Validators.required
    ]);


    this.blockForm.get('function_name')
    ?.setValidators([
      Validators.required
    ]);


    this.blockForm.get('location')
    ?.setValidators([
      Validators.required
    ]);


    this.blockForm.get('details')
    ?.setValidators([
      Validators.required
    ]);


  }



  // Personal Leave validation

  else if(type === 'Personal Leave') {


    this.blockForm.get('reason')
    ?.setValidators([
      Validators.required
    ]);


  }



  // Outside Booking validation

  else if(type === 'Outside Booking') {


    this.blockForm.get('reason')
    ?.setValidators([
      Validators.required
    ]);


    this.blockForm.get('location')
    ?.setValidators([
      Validators.required
    ]);


  }



  // Refresh validation status

  Object.keys(this.blockForm.controls)
  .forEach(field => {

    this.blockForm.get(field)
    ?.updateValueAndValidity();

  });


}

 saveBlockedDate(){


if(this.blockForm.invalid){

 this.blockForm.markAllAsTouched();

 alert(
 "Please fill all required fields"
 );

 return;

}



const data={

merchantId:this.merchantId,

...this.blockForm.value

};



this.apiService
.createBlockedDate(data)
.subscribe({

next:(res:any)=>{


console.log(
"Saved",
res
);



alert(
"Date blocked successfully"
);



this.closeBlockForm();


this.loadBlockedDates();



},


error:(err)=>{


console.log(err);


alert(
err.error.message || "Something went wrong");


}


});


}
viewDetails(item:any){

this.selectedDate=item;

this.showDetails=true;

}
closeDetails(){

this.showDetails=false;

this.selectedDate=null;

}
deleteBlockedDate(id:any){


if(!confirm("Are you sure you want to delete this blocked date?")){

return;

}



this.apiService
.deleteBlockedDate(id)
.subscribe({

next:(res:any)=>{


alert("Blocked date removed");


this.loadBlockedDates();


},


error:(err)=>{


console.log(err);

alert("Delete failed");


}


});


}
}
